import axiosClient from "../apiClient";

export const CreateTeamService = async (params: {
  name: string;
  members: { email: string; accepted: boolean; isOwner: boolean }[];
  logo: File;
}) => {
  try {
    const reqBody = {
      name: params.name,
      logo: params.logo,
      members: params.members,
    };

    const response = await axiosClient.post(`/team`, reqBody);

    return response;
  } catch (error) {
    return error;
  }
};

export const TeamDetailsService = async () => {
  try {
    const response = await axiosClient.get("/team");
    return response;
  } catch (error) {
    return error;
  }
};

export const InviteTeamMembersList = async () => {
  try {
    const response = await axiosClient.get("/team/members/list");
    return response;
  } catch (error) {
    return error;
  }
};

export const TeamRemoveMemberService = async (
  userEmail: string,
  folderId: string
) => {
  try {
    const response = await axiosClient.get(
      `/folder/remove-member?userEmail=${userEmail}&folderId=${folderId}`
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const RemoveTeamFromAccessService = async (
  folderId: string,
  teamId: string
) => {
  try {
    const body = { folderId, teamIds: [teamId] };
    const response = await axiosClient.put(`/folder/remove-team`, body);
    return response;
  } catch (error) {
    return error;
  }
};

export const SendInvitationService = async (params: { email: string }) => {
  try {
    const response = await axiosClient.post(`/team/members/inviteMember`, {
      email: params.email,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const JoinTeamService = async (params: {
  notificationId: string;
  teamId: string;
  status: string;
}) => {
  try {
    const body = {
      status: params.status,
      notificationId: params.notificationId,
    };
    const response = await axiosClient.put(
      `/team/member/joinMember/${params.teamId}`,
      body
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const DeleteMember = async (params: { email: string }) => {
  try {
    const response = await axiosClient.post(`/team/members/removeMemberUser`, {
      email: params.email,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const ChangeTeam = async (teamId: string) => {
  try {
    const response = await axiosClient.get(`/team/change/team/${teamId}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const DeleteTeam = async (id: string) => {
  try {
    const response = await axiosClient.delete(`/team/removeTeam/${id}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const TeamDetialByIdService = async (params: { teamId: string }) => {
  try {
    const response = await axiosClient.get(`/team/${params.teamId}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateTeamService = async (params: {
  teamId: string;
  formData: FormData;
}) => {
  try {
    const response = await axiosClient.put(
      `/team/updateTeam/${params.teamId}`,
      params.formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const MyteamsListService = async () => {
  try {
    const response = await axiosClient.get("/team/myteams");
    return response;
  } catch (error) {
    return error;
  }
};

export const exitTeamService = async () => {
  try {
    let response = await axiosClient.put(`/team/exitTeam`);
    return response;
  } catch (error) {
    return error;
  }
};

export const joinMemberToSeatService = async (
  teamId: string,
  payload: {
    status: "ACCEPTED" | "REJECTED";
    seatId: string;
    notificationId: string;
  }
) => {
  try {
    const response = await axiosClient.put(
      `/team/member/joinMember/${teamId}`,
      payload
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const assignSeatMemberService = async (params: {
  email: string;
  seatId: string;
}) => {
  try {
    const response = await axiosClient.post(
      `team/member/seat/assignMemberSeat/${params?.seatId}`,
      {
        email: params.email,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getTeamMembersSeatList = async () => {
  try {
    const response = await axiosClient.get("/team/members/seat/list");
    return response;
  } catch (error) {
    return error;
  }
};

export const cancelInviteSeatRequestSearvice = async (params: {
  seatId: string;
}) => {
  try {
    const response = await axiosClient.post(
      `/team/member/seat/memberSeatCancelRequest/${params?.seatId}`
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const disableSeatSearvice = async (params: { seatId: string }) => {
  try {
    const response = await axiosClient.post(
      `/team/member/seat/memberSeatDesable/${params?.seatId}`
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const enableSeatSearvice = async (params: { seatId: string }) => {
  try {
    const response = await axiosClient.post(
      `/team/member/seat/memberSeatReEnable/${params?.seatId}`
    );
    return response;
  } catch (error) {
    return error;
  }
};
export const removeSeatMemberService = async (params: { seatId: string }) => {
  try {
    const response = await axiosClient.post(
      `/team/member/seat/memberSeatRemove/${params?.seatId}`
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const memberPurchseSeatAmountDetailsService = async (body: {
  seatCount: number;
}) => {
  try {
    const response = await axiosClient.post(
      `/team/member/seat/memberPurchseSeatAmountDetails`,
      body
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const memberSelectAccessFreeSeat = async (body: { seatId: string }) => {
  try {
    const response = await axiosClient.post(
      `/team/member/seat/memberSelectAccessFreeSeat`,
      body
    );
    return response;
  } catch (error) {
    return error;
  }
};
